﻿import React, { ReactNode } from 'react';
import { styled } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';

type TabBarProps = {} & { children: ReactNode };

const StyledTabBar = styled(AppBar)(({ theme }) => ({
    backgroundColor: theme.palette.primary.dark
}));

function TabBar({ children }: TabBarProps) {
    return (
        <StyledTabBar
            position="fixed"
            sx={{ top: '48px' }}
            color="primary"
            style={{ height: '48px' }}
        >
            {children}
        </StyledTabBar>
    );
}

export default TabBar;
